import { CollectionPageState } from './CollectionPageState';
import { WixPatternsContainer } from '../WixPatternsContainer';
import { ReactNode } from 'react';

type PanelId =
  | 'filters'
  | 'customColumns'
  | 'multiLevelSorting'
  | 'customFields';

type MoreActionItemFactory = (params: {
  pageState: CollectionPageState;
  container: WixPatternsContainer;
}) => {
  text: string;
  onClick: (params?: Record<string, any>) => unknown;
  prefixIcon?: ReactNode;
  dataHook?: string;
};

export interface ToolbarCollectionState {
  panels: {
    openSidePanel(panelId: PanelId): void;
  };
  getPageFeaturedActions(): MoreActionItemFactory[];
  tagsCollectionState: {
    openManageTagsModal(): void;
  } | null;
}
